







































import Vue from 'vue'
import { INavMenuItem } from '@/types/data-objects/global'

export default Vue.extend({
  name: 'NavMenu',

  props: {
    value: {
      type: String || Number,
      default: '',
    },
    elements: {
      type: Array as () => INavMenuItem[],
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
  },

  methods: {
    getFilterCount(item: INavMenuItem) {
      if (item.count !== null) {
        if (item.count > 999) {
          return '999+'
        }
        return item.count
      }
      return ''
    },
  },
})
